var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBikeAllowed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4776_2414)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4776_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9955 0C13.4198 0 4 9.42181 4 21C4 32.5782 13.4198 42 24.9955 42C36.5712 42 45.9911 32.5782 45.9911 21C45.9911 9.42181 36.5802 0 24.9955 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9618 34.0903L36.795 35.2177C37.4838 34.6451 38.11 34.0188 38.7094 33.3566L10.2263 32.0592C10.7631 32.775 11.3266 33.4551 11.9618 34.0814",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30291 28.8739L40.9099 30.3592C41.2678 29.7418 41.6077 29.1155 41.894 28.4533L7.4978 26.8875C7.73039 27.5675 7.99876 28.2297 8.30291 28.8739Z",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4971 37.4009C19.0376 38.7252 21.9271 39.4857 24.9955 39.4857C27.4645 39.4857 29.8261 38.9936 31.9821 38.1078L16.4971 37.4009Z",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75533 23.7469L42.9317 25.3933C43.0838 24.758 43.209 24.1138 43.2985 23.4606L6.57642 21.7874C6.60325 22.4495 6.66587 23.1027 6.76428 23.7469",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6689 4.04431L33.8517 4.77802C31.2217 3.33746 28.207 2.52322 25.0044 2.52322C22.4012 2.52322 19.9233 3.06903 17.6689 4.04431Z",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1477 8.79549L39.8991 10.1018C39.3803 9.38603 38.8167 8.70601 38.1995 8.07968L13.0352 6.93439C12.3643 7.50703 11.7381 8.13336 11.1567 8.79549",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02555 13.7077L42.5559 15.2825C42.3323 14.6025 42.0639 13.9404 41.7687 13.2961L8.98274 11.8019C8.62491 12.4193 8.30286 13.0456 8.0166 13.7077",
    fill: "#60B7C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03248 16.7588C6.8804 17.3941 6.7641 18.0383 6.68359 18.6915L43.4414 20.3647C43.4235 19.7026 43.3609 19.0494 43.2715 18.4141L7.03248 16.7588Z",
    fill: "#60B7C2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4776_2414",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4776_2414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4776_2414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4776_2414"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeAllowed);
export default __webpack_public_path__ + "static/media/bike-allowed.669215054bf9c0fc004f3486c2018b87.svg";
export { ForwardRef as ReactComponent };